import { render } from "./OrganizationProfile.vue?vue&type=template&id=30be8c6c&scoped=true"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"

import "./OrganizationProfile.vue?vue&type=style&index=0&id=30be8c6c&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30be8c6c"]])

export default __exports__